import React, { useState } from 'react';
import EdenredButtons from '@pages/DesignSystem/button/EdenredButton';
import Edenredmodal from '../index';

const ModelSix = () => {
	const [isOpen, setisOpen] = useState(false);

	return (
		<>
			<EdenredButtons
				{...{
					btnType: 'primary',
					onClick: () => setisOpen(true),
					style: { marginTop: '20px' },
				}}>
				Modal With heart and two button
			</EdenredButtons>

			<Edenredmodal
				{...{
					title: 'Do You Want To Continue?',
					desc: 'Edenred',
					onOkay: 'abc',
					onCancelButton: 'Cancel',
					onOkayButton: 'Save',
					onCancel: () => setisOpen(false),
					isOpen: isOpen,
					heart: true,
				}}
			/>
		</>
	);
};

export default ModelSix;
